module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAm0lEQVQ4y2NgGBTgP5kAbsBjLvH/5GC8Lvj7+g0YE+UCFNE/f/5/27AFbMP7osr/P/YfBpr2l3gDvu8+ANb8+/lLFMWfJk7//+vKNcIGfGzq/P++qvH/74eP4GJfV64FG/rj0DHCBnzbsRvigqs3URR/27j1/+/7D4kLg69rNoENeZuQ+f/HkeOkhQEM/Pv2HYwHLh2QlBKHNgAAnAkYGhDh4+8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/_northern-cyprus.png
// module id = 1318
// module chunks = 0